<template>
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Acciones</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div
              class="col"
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <label for="ruleNumberRequest" style="padding-bottom: 5px"
                >Cantidad de referencias requeridas*</label
              >
              <input name="" id="ruleNumberRequest" v-model="value" />
            </div>
            <div
              class="col"
              style="display: flex; justify-content: center; padding-top: 35px"
            >
              <button class="btn btn-success" @click="editRule">Guardar Cambios</button>
            </div>
            <div class="col-12" v-if="viewAlert">
              <div class="alert alert-success">Actualizacion Completada</div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            @click="resetAll"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: ["rule_id", "number_references_require"],
  name: "",
  data() {
    return {
      value: 0,
      viewAlert: false,
    };
  },
  components: {},
  methods: {
    setCredentials() {
      this.token = document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content");
      axios.defaults.headers["x-csrf-token"] = this.token;
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    },
    async editRule() {
      let ruleResult;
      try {
        this.setCredentials();
        let number = this.numberReferencesRequire;
        ruleResult = await axios.put(`/api/v1/clients/rules/${this.rule_id}`, {
          rule: { number_references_require: number },
        });
        if (ruleResult.status == 200) {
          this.viewAlert = true;
          this.$emit("update-item", this.value);
        }
        console.log(ruleResult);
      } catch (error) {
        console.log(error);
      }
    },
    resetAll() {
      this.value = 0;
      this.viewAlert = false;
    },
  },
  computed: {
    numberReferencesRequire: {
      get() {
        return this.number_references_require;
      },
      set(value) {
        console.log("Cambiando", value);
        this.$emit("eventupdate", value);
        this.$emit("update:number_references_require", value);
      },
    },
  },
  watch: {
    value(val) {
      this.numberReferencesRequire = val;
    },
  },
};
</script>

<style lang="" scoped></style>
